import { useCallback } from 'react';
import { ADD_SUCCESS_ALERT, ADD_ERROR_ALERT, ADD_DANGER_ALERT, ADD_WARNING_ALERT, ADD_REFRESH_ALERT, REMOVE_REFRESH_ALERT } from 'crm-events-data';
import { addSuccess, addError, addDanger, addWarning
// @ts-expect-error Could not find a declaration file
} from 'customer-data-ui-utilities/alerts/Alerts';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import I18n from 'I18n';
import once from 'transmute/once';
import { jsx as _jsx } from "react/jsx-runtime";
let addRefreshAlertOnce;
function addRefreshAlert(boundaryName) {
  FloatingAlertStore.addAlert({
    id: boundaryName,
    type: 'danger',
    use: 'inline',
    titleText: I18n.text('componentErrorAlert.title'),
    message: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "componentErrorAlert.message_jsx",
      options: {
        href: window.location.href
      },
      elements: {
        Link
      }
    }),
    // if they close the alert, reset the timer in case something else breaks
    onClose: () => {
      addRefreshAlertOnce = once(addRefreshAlert);
    }
  });
}
export const useAlertsActionHandler = () => {
  // if a bunch of things break at the same time, during a critsit or something,
  // we don't want to show the alert a million times. show it once, and reset if
  // they clear it (see onClose above)
  addRefreshAlertOnce = once(addRefreshAlert);
  const handleAlertsAction = useCallback((actionType, data) => {
    switch (actionType) {
      case ADD_SUCCESS_ALERT:
        addSuccess(data.message, data.messageOptions);
        return;
      case ADD_ERROR_ALERT:
        addError(data.message, data.messageOptions);
        return;
      case ADD_DANGER_ALERT:
        addDanger(data.message, data.messageOptions);
        return;
      case ADD_WARNING_ALERT:
        addWarning(data.message, data.messageOptions);
        return;
      case ADD_REFRESH_ALERT:
        addRefreshAlertOnce(data.boundaryName);
        return;
      case REMOVE_REFRESH_ALERT:
        FloatingAlertStore.removeAlert(data.boundaryName);
        return;
      default:
        return;
    }
  }, []);
  return {
    handleAlertsAction
  };
};